"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var uuid_1 = require("uuid");
var stringifyWithoutCircular = function (json) {
    var getCircularReplacer = function () {
        var seen = new WeakSet();
        return function (_key, value) {
            if (typeof value === "object" && value !== null) {
                if (seen.has(value)) {
                    return;
                }
                seen.add(value);
            }
            return value;
        };
    };
    return JSON.stringify(json, getCircularReplacer());
};
var Client = /** @class */ (function (_super) {
    __extends(Client, _super);
    function Client() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            runningViews: [],
        };
        _this.componentDidMount = function () {
            _this.props.transport.on("update_views_tree", function (_a) {
                var views = _a.views;
                _this.setState({ runningViews: views });
            });
            _this.props.transport.on("update_view", function (_a) {
                var view = _a.view;
                _this.setState(function (state) {
                    var runningView = state.runningViews.find(function (currentView) { return currentView.uid === view.uid; });
                    if (runningView) {
                        runningView.props = runningView.props.filter(function (prop) { return !view.props.delete.includes(prop.name); });
                        view.props.create.forEach(function (newProp) {
                            runningView.props.push(newProp);
                        });
                    }
                    else {
                        state.runningViews.push(__assign(__assign({}, view), { props: view.props.create }));
                    }
                    return { runningViews: __spreadArrays(state.runningViews) };
                });
            });
            _this.props.transport.on("delete_view", function (_a) {
                var viewUid = _a.viewUid;
                _this.setState(function (state) {
                    var runningViewIndex = state.runningViews.findIndex(function (view) { return view.uid === viewUid; });
                    if (runningViewIndex !== -1) {
                        state.runningViews.splice(runningViewIndex, 1);
                        return { runningViews: __spreadArrays(state.runningViews) };
                    }
                });
            });
            if (_this.props.requestViewTreeOnMount) {
                _this.props.transport.emit("request_views_tree");
            }
        };
        _this.renderView = function (view) {
            var componentToRender = _this.props.views[view.name];
            var props = { key: view.uid };
            view.props.forEach(function (prop) {
                if (prop.type === "data") {
                    props[prop.name] = prop.data;
                }
                else if (prop.type === "event")
                    [
                        (props[prop.name] = function () {
                            var args = [];
                            for (var _i = 0; _i < arguments.length; _i++) {
                                args[_i] = arguments[_i];
                            }
                            return new Promise(function (resolve) {
                                var requestUid = uuid_1.v4();
                                _this.props.transport.on("respond_to_event", function (_a) {
                                    var data = _a.data, uid = _a.uid, eventUid = _a.eventUid;
                                    if (uid === requestUid && eventUid === prop.uid) {
                                        resolve(data);
                                    }
                                });
                                _this.props.transport.emit("request_event", {
                                    eventArguments: JSON.parse(stringifyWithoutCircular(args)),
                                    eventUid: prop.uid,
                                    uid: requestUid,
                                });
                            });
                        }),
                    ];
            });
            var children = _this.state.runningViews
                .filter(function (runningView) { return runningView.parentUid === view.uid; })
                .sort(function (a, b) { return a.childIndex - b.childIndex; })
                .map(function (runningView) { return _this.renderView(runningView); });
            return react_1.default.createElement(componentToRender, __assign(__assign({}, props), { children: children.length > 0 ? children : undefined }));
        };
        _this.render = function () {
            var roots = _this.state.runningViews.filter(function (view) { return view.isRoot; });
            if (roots.length === 0) {
                return react_1.default.createElement(react_1.default.Fragment, null);
            }
            return roots.map(_this.renderView);
        };
        return _this;
    }
    return Client;
}(react_1.default.Component));
exports.default = Client;
